import { MARKETING_SITE_URL } from "@/web/lib/siteUrls";
import { cn } from "@/web/lib/styling";

/**
 * The prototype's yellow "vision" sticker, out to the with.us manifesto site.
 * Shared by the marketing navbar and the homepage footer band.
 */
export function WithUsCta({ className }: { className?: string }) {
  return (
    <a
      href={MARKETING_SITE_URL}
      className={cn(
        "inline-block shrink-0 bg-[#ead244] px-[15px] py-[13px] font-heading text-[15px] leading-none font-black text-[#34308b] uppercase shadow-[2px_2px_0_#34308b] hover:opacity-70",
        className,
      )}
    >
      ARE YOU WITH.US?
    </a>
  );
}
